import { FC, useRef, useState } from 'react';
import classNames from 'classnames/bind';
import { ReactComponent as IconSearch } from './img/iconSearch.svg';
import { ReactComponent as IconEnter } from './img/enter.svg';
import { ReactComponent as CloseSvg } from 'assets/img/close.svg';
import { Box, Group, Loader } from '@mantine/core';
import styles from './InputSearch.module.scss';

const cx = classNames.bind(styles);

type InputSearchProps = {
  placeholder?: string;
  value: string;
  onChange?: any;
  props?: any;
  style?: any;
  border?: boolean;
  onKeyDown?: (event: KeyboardEvent) => void;
  focus?: boolean;
  setFocus?: ((b: boolean) => void) | any;
  notFocus?: boolean;
  onSearch?: () => void;
  fetching?: boolean;
};

export const InputSearch: FC<InputSearchProps> = ({
  placeholder = 'Искать...',
  value,
  onChange,
  props,
  style,
  border,
  onKeyDown,
  setFocus,
  focus,
  notFocus,
  onSearch,
  fetching,
}) => {
  const inputRef = useRef<any>(null);
  const [searchClicked, setSearchClicked] = useState(false);

  const classNameInput = cx({
    input: true,
    focus: focus,
    input_with_left_icon: !value,
  });

  const classNameRoot = cx({
    root: true,
    root_border: border,
  });

  const handleClear = () => {
    if (fetching) return;
    if (onChange) {
      onChange({ target: { value: '' } });
    }
    setSearchClicked(false);
    inputRef.current?.focus();
  };

  const handleSearch = () => {
    if (onSearch) {
      onSearch();
    }
    setSearchClicked(true);
  };

  const handleInputChange = (event: any) => {
    if (onChange) {
      onChange(event);
    }
    setSearchClicked(false);
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter' && onSearch) {
      handleSearch();
    }
    if (onKeyDown) {
      onKeyDown(event as unknown as KeyboardEvent);
    }
  };

  return (
    <div className={classNameRoot}>
      {!value && <IconSearch className={styles.root_icon_left} />}
      <input
        placeholder={placeholder}
        style={{ ...style, paddingRight: onSearch && !searchClicked ? '98px' : '59px' }}
        className={classNameInput}
        ref={inputRef}
        onChange={handleInputChange}
        onFocus={notFocus ? undefined : () => setFocus?.(true)}
        autoComplete='disabled'
        onKeyDown={handleKeyDown}
        value={value}
        {...props}
      />

      {value && (
        <Group gap='8px' className={styles.root_actions}>
          <CloseSvg
            className={styles.root_clear}
            style={!onSearch || searchClicked ? { marginRight: '8px' } : {}}
            onClick={handleClear}
          />
          {onSearch && !searchClicked ? (
            <Box className={styles.root_search} onClick={handleSearch}>
              {<IconEnter />}
            </Box>
          ) : null}
        </Group>
      )}
    </div>
  );
};
